import styled from 'styled-components';
import { rem } from 'polished';

export const OfferDemandedWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    border-top: 2px solid ${({ theme }) => theme.colors.grey7};
    background-color: ${({ theme }) => theme.colors.white};
    padding: ${rem('15px')} ${rem('30px')};
    color: ${({ theme }) => theme.colors.grey13};

    .offer_demanded_title {
        font-weight: ${({ theme }) => theme.fontWeights.textMedium};
        font-size: ${({ theme }) => theme.fontSizes.textSupMedium};
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.black};
    }

    .offer_demanded_line {
        position: absolute;
        top: 0;
        left: -2px;
        width: 4px;
        height: 100%;
        background-color: ${({ theme }) => theme.colors.red5};
    }
`;
